import type { MemoryStatsPayload } from "schemas/generated/agentConnection";

import { createShallowStore } from "replo-utils/react/zustand";

/** Only keep snapshots from the last 5 minutes */
const RETENTION_MS = 5 * 60 * 1000;

type DebugMemoryStatsState = {
  /** Memory snapshots keyed by sandboxId */
  snapshots: Record<string, MemoryStatsPayload[]>;
  actions: {
    addSnapshot: (snapshot: MemoryStatsPayload) => void;
    clearStats: () => void;
  };
};

const useDebugMemoryStatsStore = createShallowStore<DebugMemoryStatsState>(
  (set) => ({
    snapshots: {},
    actions: {
      addSnapshot: (snapshot: MemoryStatsPayload) => {
        set((state) => {
          const cutoff = Date.now() - RETENTION_MS;
          const existing = state.snapshots[snapshot.sandboxId] ?? [];
          const pruned = existing.filter((s) => s.timestamp > cutoff);
          return {
            snapshots: {
              ...state.snapshots,
              [snapshot.sandboxId]: [...pruned, snapshot],
            },
          };
        });
      },
      clearStats: () => {
        set({ snapshots: {} });
      },
    },
  }),
);

export const useDebugMemorySnapshots = () => {
  return useDebugMemoryStatsStore((state) => state.snapshots);
};

export const useDebugMemoryStatsActions = () => {
  return useDebugMemoryStatsStore((state) => state.actions);
};
